import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/storybook-components/dist/Box'
import { Button } from '@node-space/ui-components'
import { RequestErrorCallout } from 'components/Errors/RequestErrorCallout'
import { AddCustomerPayload, CustomerEntityType } from 'types/customers'
import { MappedErrorMessageState } from 'types/errors'
import { CompanyCustomerConfirmation } from './CompanyCustomerConfirmation'
import { IndividualCustomerConfirmation } from './IndividualCustomerConfirmation'

type AddCustomerConfirmProps = {
  onContinue: () => void
  isLoading: boolean
  customer: AddCustomerPayload
  onBack: () => void
  requestError: MappedErrorMessageState
  resetRequestError: () => void
}

export const AddCustomerConfirm = ({
  customer,
  onContinue,
  isLoading,
  onBack,
  requestError,
  resetRequestError,
}: AddCustomerConfirmProps) => {
  const { t } = useTranslation()
  const isCompanyCustomer = customer?.customerEntityType === CustomerEntityType.COMPANY

  const handleOnBack = () => {
    resetRequestError()
    onBack()
  }

  return (
    <Box flex direction="col" width={'full'} gapY={20}>
      <Box
        flex
        direction="col"
        padding={24}
        gapY={12}
        background="white"
        border="gray"
        className="h-fit"
        borderRadius={8}
      >
        {isCompanyCustomer ? (
          <CompanyCustomerConfirmation customer={customer} />
        ) : (
          <IndividualCustomerConfirmation customer={customer} />
        )}

        {requestError?.show && <RequestErrorCallout requestError={requestError} />}
      </Box>
      <Box flex justifyContent="between">
        <Button variant="secondary" onClick={handleOnBack}>
          {t('back')}
        </Button>
        <Button loading={isLoading} onClick={onContinue}>
          {t('confirm')}
        </Button>
      </Box>
    </Box>
  )
}
